export default "__VITE_ASSET__BTN669pC__"